import { useAuth } from '@/services/auth';
import { useCurrentWorkspace } from '@/context/current-workspace';
import { generatePath } from '@/services/router/generate-path';
import { Link } from '@customerio/pluma-components/react';
import { AuditLogsPageContainer } from './components/audit-logs-page-container';

export const AccountAuditLogs = () => {
  const auth = useAuth();
  const currentAccountId = auth.account.id;
  const currentWorkspace = useCurrentWorkspace();
  const workspaceId = currentWorkspace?.id;

  return (
    <AuditLogsPageContainer
      context="account"
      contextId={currentAccountId}
      workspaceId={workspaceId ?? null}
      breadcrumbs={[
        { id: 'account_settings', text: 'Settings', href: '/settings' },
        { id: 'audit_logs', text: 'Audit logs', href: '/settings/audit-logs' },
      ]}
      pageTitle="Account Audit Logs"
      pageDescription={
        <>
          View audit logs to track account-level changes. Looking for workspace-level changes like campaigns or
          segments?{' '}
          {workspaceId != null && workspaceId > 0 ? (
            <Link href={generatePath('/workspaces/:workspaceId/settings/audit-logs', { workspaceId })}>
              View Workspace Audit Logs
            </Link>
          ) : (
            'View Workspace Audit Logs in your workspace settings.'
          )}
        </>
      }
      backUrlBase="/settings/audit-logs"
      feedbackFeature="Account Audit Logs"
    />
  );
};
